import { useCurrencies } from "@/modules/reports/contexts/currency-context";
import { useQuery } from "@tanstack/react-query";
import { getItemsFromCollection } from "directus/src/operations";


const calculateOverviewStats = (billables, convertToINR) => {
  const totalAmount = billables.reduce((sum, billable) => {
    const { status } = billable;
    const amountField = status === "contracted" || status === "pending_invoice" || status === "cancelled" ? "amount" : "adjusted_amount";
    const convertedAmount = convertToINR(billable[amountField], billable.currency);
    return sum + convertedAmount;
  }, 0);

  return {
    totalAmount,
    count: billables.length,
  };
};

export const useBillableStats = (status, filters) => {
  const { convertToINR, isLoading: currenciesLoading } = useCurrencies();

  return useQuery({
    queryKey: ["billable-overview-stats", status, filters],
    queryFn: async () => {

      const billablesQuery = {
        fields: [
          "id",
          "amount",
          "adjusted_amount",
          "currency",
          "status",

        ],
        filter: {
          status: { _eq: status },

          job: { project: { _nnull: true } },
          ...filters,
        },
        limit: -1,
      };

      const billablesResponse = await getItemsFromCollection(
        "billables",
        billablesQuery
      );

      return calculateOverviewStats(billablesResponse, convertToINR);
    },
    enabled: !currenciesLoading, // Wait for currencies to load first
  });
};
